import ProductComparisonSectionNew, { ProductComparisonSectionNewProps } from './product-comparison-section-new'
import { ProductComparisonTableNewProps, ProductComparisonProductNewProps } from './product-comparison-table-new'

export default ProductComparisonSectionNew
export { ProductComparisonSectionNew }
export type { ProductComparisonSectionNewProps, ProductComparisonProductNewProps, ProductComparisonTableNewProps }
